import { forwardRef } from "react";
import { useNavigationItem } from "../hooks/useNavigationItem";

export const withAppSideBarNav = (Component: React.ComponentType<any>) => {
  return forwardRef(
    (
      {
        route,
        children,
        ...props
      }: {
        route: string;
        children: React.ReactNode;
      },
      ref,
    ) => {
      const { navigateTo } = useNavigationItem(route);

      return (
        <Component ref={ref} onClick={() => navigateTo(route)} {...props}>
          {children}
        </Component>
      );
    },
  );
};
